import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const branchDpiLocaleModule: LocaleModule = {
  name: "branchDpi",
  messages: { en: en, it: it },
};
